export const categories = [
  { slug: 'romance', name: '恋爱漫', icon: 'ri-heart-line' },
  { slug: 'action', name: '热血漫', icon: 'ri-fire-line' },
  { slug: 'fantasy', name: '奇幻漫', icon: 'ri-magic-line' },
  { slug: 'drama', name: '剧情漫', icon: 'ri-emotion-line' },
  { slug: 'comedy', name: '搞笑漫', icon: 'ri-emotion-happy-line' },
  { slug: 'thriller', name: '悬疑漫', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL漫', icon: 'ri-men-line' },
  { slug: 'gl', name: 'GL漫', icon: 'ri-women-line' },
  { slug: 'daily', name: '日常漫', icon: 'ri-sun-line' },
  { slug: 'horror', name: '恐怖漫', icon: 'ri-ghost-line' },
];

export const comics = [
  {
    id: 'secretary-escape',
    slug: 'secretary-escape',
    title: '秘书的逃脱',
    author: 'KIM Jihyun',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20beautiful%20female%20secretary%20in%20office%20attire%20with%20intense%20expression%2C%20dark%20office%20background%2C%20dramatic%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20clean%20lines%2C%20vibrant%20colors%2C%20cinematic%20composition%2C%20soft%20shadows%2C%20high%20quality%20illustration&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    rating: 9.8,
    status: '连载中',
    categories: ['romance', 'drama'],
    description: '在一家顶级企业工作多年的金秘书，某天突然发现自己卷入了一场巨大的阴谋。为了生存，她必须在权力与爱情之间做出选择。',
    views: 1258000,
    updatedAt: '2026-07-03',
    isHot: true,
    isRecommended: true,
    chapters: [
      { id: 'ch-67', number: 67, title: '最后的抉择', updatedAt: '2026-07-03' },
      { id: 'ch-66', number: 66, title: '真相浮现', updatedAt: '2026-06-30' },
      { id: 'ch-65', number: 65, title: '暗流涌动', updatedAt: '2026-06-27' },
      { id: 'ch-64', number: 64, title: '危机四伏', updatedAt: '2026-06-24' },
      { id: 'ch-63', number: 63, title: '意外的相遇', updatedAt: '2026-06-21' },
    ],
  },
  {
    id: 'demon-lord',
    slug: 'demon-lord',
    title: '魔王大人的契约',
    author: 'PARK Minsoo',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20handsome%20demon%20lord%20with%20dark%20hair%20and%20red%20eyes%2C%20gothic%20fantasy%20setting%2C%20elegant%20dark%20castle%20background%2C%20Korean%20webtoon%20art%20style%2C%20rich%20color%20palette%2C%20luxurious%20outfit%2C%20magical%20aura%2C%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    categories: ['fantasy', 'romance'],
    description: '平凡的女大学生与异世界的魔王签订了灵魂契约，从此过上了与恶魔共同生活的奇妙日常。爱情在不知不觉中悄然萌芽。',
    views: 980000,
    updatedAt: '2026-07-02',
    isHot: true,
    isRecommended: true,
    chapters: [
      { id: 'ch-89', number: 89, title: '契约的代价', updatedAt: '2026-07-02' },
      { id: 'ch-88', number: 88, title: '觉醒', updatedAt: '2026-06-29' },
      { id: 'ch-87', number: 87, title: '命运的齿轮', updatedAt: '2026-06-26' },
      { id: 'ch-86', number: 86, title: '夜幕降临', updatedAt: '2026-06-23' },
      { id: 'ch-85', number: 85, title: '新的力量', updatedAt: '2026-06-20' },
    ],
  },
  {
    id: 'bakery-love',
    slug: 'bakery-love',
    title: '面包店的春天',
    author: 'LEE Sora',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20cute%20baker%20girl%20in%20a%20warm%20bakery%20shop%2C%20soft%20pastel%20colors%2C%20cozy%20atmosphere%2C%20Korean%20webtoon%20art%20style%2C%20gentle%20lighting%2C%20delicate%20linework%2C%20romantic%20vibe%2C%20clean%20background%2C%20charming%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    rating: 9.5,
    status: '已完结',
    categories: ['romance', 'daily'],
    description: '在首尔一条安静的小巷里，一家手工面包店的故事正在甜蜜展开。面包师小姐姐与隔壁咖啡店老板之间，温度刚刚好的爱情。',
    views: 1530000,
    updatedAt: '2026-06-15',
    isHot: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-120', number: 120, title: '春天的约定（完）', updatedAt: '2026-06-15' },
      { id: 'ch-119', number: 119, title: '告白', updatedAt: '2026-06-12' },
      { id: 'ch-118', number: 118, title: '心意相通', updatedAt: '2026-06-09' },
      { id: 'ch-117', number: 117, title: '暖心的礼物', updatedAt: '2026-06-06' },
      { id: 'ch-116', number: 116, title: '雨中的相遇', updatedAt: '2026-06-03' },
    ],
  },
  {
    id: 'warrior-rebirth',
    slug: 'warrior-rebirth',
    title: '重生之最强战士',
    author: 'CHOI Dongwook',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20powerful%20warrior%20with%20sword%20in%20epic%20fantasy%20battlefield%2C%20dynamic%20action%20pose%2C%20dramatic%20lighting%20effects%2C%20Korean%20webtoon%20art%20style%2C%20vibrant%20energy%20effects%2C%20heroic%20composition%2C%20clean%20lines%2C%20intense%20colors&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    rating: 9.7,
    status: '连载中',
    categories: ['action', 'fantasy'],
    description: '曾经的最强战士在战场陨落后，带着前世的记忆重生回到了二十年前。这一次，他要改写命运，成为真正的传说。',
    views: 2100000,
    updatedAt: '2026-07-03',
    isHot: true,
    isRecommended: false,
    chapters: [
      { id: 'ch-45', number: 45, title: '觉醒之战', updatedAt: '2026-07-03' },
      { id: 'ch-44', number: 44, title: '试炼之路', updatedAt: '2026-06-30' },
      { id: 'ch-43', number: 43, title: '古老的遗迹', updatedAt: '2026-06-27' },
      { id: 'ch-42', number: 42, title: '敌人的阴影', updatedAt: '2026-06-24' },
      { id: 'ch-41', number: 41, title: '新的同伴', updatedAt: '2026-06-21' },
    ],
  },
  {
    id: 'thriller-night',
    slug: 'thriller-night',
    title: '午夜追踪者',
    author: 'JUNG Hyunwoo',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20detective%20in%20dark%20alley%20at%20night%2C%20noir%20atmosphere%2C%20rainy%20streets%2C%20mysterious%20silhouette%2C%20Korean%20webtoon%20thriller%20art%20style%2C%20moody%20lighting%2C%20suspenseful%20composition%2C%20clean%20lines&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    rating: 9.4,
    status: '连载中',
    categories: ['thriller', 'drama'],
    description: '首尔深夜的街头，连环案件接连发生。一位年轻的刑警在追查真相的过程中，发现自己正在接近一个令人难以置信的秘密。',
    views: 760000,
    updatedAt: '2026-07-01',
    isHot: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-54', number: 54, title: '最后的线索', updatedAt: '2026-07-01' },
      { id: 'ch-53', number: 53, title: '隐藏的真相', updatedAt: '2026-06-28' },
      { id: 'ch-52', number: 52, title: '第四名嫌疑人', updatedAt: '2026-06-25' },
      { id: 'ch-51', number: 51, title: '审讯室', updatedAt: '2026-06-22' },
      { id: 'ch-50', number: 50, title: '致命线索', updatedAt: '2026-06-19' },
    ],
  },
  {
    id: 'school-comedy',
    slug: 'school-comedy',
    title: '校园爆笑日常',
    author: 'YOON Jaehyun',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20funny%20high%20school%20students%20in%20classroom%2C%20comedy%20expressions%2C%20bright%20and%20colorful%2C%20Korean%20webtoon%20art%20style%2C%20energetic%20composition%2C%20clean%20lines%2C%20vibrant%20colors%2C%20playful%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    rating: 9.3,
    status: '已完结',
    categories: ['comedy', 'daily'],
    description: '一群性格迥异的高中生们在校园里发生的各种令人捧腹大笑的日常趣事。没有狗血，只有纯粹的欢乐与青春。',
    views: 890000,
    updatedAt: '2026-05-20',
    isHot: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-98', number: 98, title: '毕业快乐（完）', updatedAt: '2026-05-20' },
      { id: 'ch-97', number: 97, title: '最后的恶作剧', updatedAt: '2026-05-17' },
      { id: 'ch-96', number: 96, title: '学园祭大作战', updatedAt: '2026-05-14' },
      { id: 'ch-95', number: 95, title: '考试前的疯狂', updatedAt: '2026-05-11' },
      { id: 'ch-94', number: 94, title: '转校生', updatedAt: '2026-05-08' },
    ],
  },
  {
    id: 'bl-spring',
    slug: 'bl-spring',
    title: '春日恋语',
    author: 'HAN Jiwon',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20two%20handsome%20young%20men%20under%20cherry%20blossoms%2C%20romantic%20spring%20atmosphere%2C%20soft%20pink%20and%20white%20color%20palette%2C%20Korean%20BL%20webtoon%20art%20style%2C%20gentle%20lighting%2C%20emotional%20composition%2C%20clean%20lines&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    rating: 9.6,
    status: '连载中',
    categories: ['bl', 'romance'],
    description: '大学校园里，两个性格截然不同的男生在春天相遇。一个是阳光开朗的学长，一个是安静内向的学弟，命运的红线悄然将他们连接。',
    views: 1100000,
    updatedAt: '2026-07-02',
    isHot: true,
    isRecommended: true,
    chapters: [
      { id: 'ch-73', number: 73, title: '春风拂面', updatedAt: '2026-07-02' },
      { id: 'ch-72', number: 72, title: '默契', updatedAt: '2026-06-29' },
      { id: 'ch-71', number: 71, title: '靠近的心', updatedAt: '2026-06-26' },
      { id: 'ch-70', number: 70, title: '意外的约会', updatedAt: '2026-06-23' },
      { id: 'ch-69', number: 69, title: '樱花树下', updatedAt: '2026-06-20' },
    ],
  },
  {
    id: 'horror-mansion',
    slug: 'horror-mansion',
    title: '凶宅笔记',
    author: 'KANG Soojin',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20haunted%20mansion%20with%20eerie%20atmosphere%2C%20dark%20gothic%20building%2C%20moonlit%20night%2C%20Korean%20horror%20webtoon%20art%20style%2C%20spooky%20lighting%2C%20mysterious%20shadows%2C%20clean%20lines%2C%20suspenseful%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    rating: 9.2,
    status: '连载中',
    categories: ['horror', 'thriller'],
    description: '一对新婚夫妇搬进了一栋价格异常便宜的老宅。然而从入住的第一天起，诡异的事情就接连不断。这座宅子，藏着不为人知的秘密。',
    views: 620000,
    updatedAt: '2026-06-28',
    isHot: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-38', number: 38, title: '地下室', updatedAt: '2026-06-28' },
      { id: 'ch-37', number: 37, title: '镜中的脸', updatedAt: '2026-06-25' },
      { id: 'ch-36', number: 36, title: '墙里的声音', updatedAt: '2026-06-22' },
      { id: 'ch-35', number: 35, title: '第二夜', updatedAt: '2026-06-19' },
      { id: 'ch-34', number: 34, title: '乔迁之日', updatedAt: '2026-06-16' },
    ],
  },
  {
    id: 'gl-campus',
    slug: 'gl-campus',
    title: '她的旋律',
    author: 'SHIN Yuna',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20two%20beautiful%20female%20music%20students%20in%20practice%20room%2C%20soft%20warm%20lighting%2C%20musical%20instruments%2C%20Korean%20GL%20webtoon%20art%20style%2C%20gentle%20atmosphere%2C%20romantic%20composition%2C%20clean%20lines%2C%20elegant%20feel&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    rating: 9.5,
    status: '连载中',
    categories: ['gl', 'romance', 'daily'],
    description: '音乐学院里，钢琴天才与吉他少女的相遇。音符之间，一种超越友情的特殊情感正在悄悄生长。',
    views: 850000,
    updatedAt: '2026-07-01',
    isHot: false,
    isRecommended: true,
    chapters: [
      { id: 'ch-56', number: 56, title: '合奏', updatedAt: '2026-07-01' },
      { id: 'ch-55', number: 55, title: '心动的音符', updatedAt: '2026-06-28' },
      { id: 'ch-54', number: 54, title: '两个人的练习室', updatedAt: '2026-06-25' },
      { id: 'ch-53', number: 53, title: '第一次对话', updatedAt: '2026-06-22' },
      { id: 'ch-52', number: 52, title: '迎新晚会', updatedAt: '2026-06-19' },
    ],
  },
  {
    id: 'action-gang',
    slug: 'action-gang',
    title: '街头之王',
    author: 'BAEK Seungho',
    cover: 'https://readdy.ai/api/search-image?query=Manhwa%20style%20illustration%20of%20a%20street%20fighter%20in%20urban%20night%20setting%2C%20dynamic%20action%20pose%2C%20neon%20lights%2C%20Korean%20action%20webtoon%20art%20style%2C%20gritty%20urban%20atmosphere%2C%20intense%20colors%2C%20powerful%20composition%2C%20clean%20lines&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    rating: 9.4,
    status: '已完结',
    categories: ['action', 'drama'],
    description: '从一个普通高中生到称霸街头的传奇人物，这条路充满了血与泪。真实而残酷的街头生存法则，热血沸腾的战斗场面。',
    views: 1780000,
    updatedAt: '2026-04-30',
    isHot: false,
    isRecommended: false,
    chapters: [
      { id: 'ch-150', number: 150, title: '王者归来（完）', updatedAt: '2026-04-30' },
      { id: 'ch-149', number: 149, title: '最终决战', updatedAt: '2026-04-27' },
      { id: 'ch-148', number: 148, title: '兄弟', updatedAt: '2026-04-24' },
      { id: 'ch-147', number: 147, title: '背叛', updatedAt: '2026-04-21' },
      { id: 'ch-146', number: 146, title: '全面战争', updatedAt: '2026-04-18' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小猫咪爱吃鱼',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20cute%20young%20woman%20with%20dark%20hair%2C%20simple%20light%20background%2C%20clean%20illustration%20style%2C%20friendly%20expression&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '这个网站的韩漫资源真的太全了！我追的好几部漫画这里都有，而且更新速度超快，基本韩国那边更新第二天这边就能看到中文版了，太赞了！下拉式阅读也很方便。',
    date: '2026-06-28',
  },
  {
    id: 2,
    name: '漫游者老王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20cool%20young%20man%20with%20glasses%2C%20simple%20dark%20background%2C%20clean%20illustration%20style%2C%20friendly%20expression&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '作为韩漫老粉，073漫画网真的是我用过体验最好的平台。无删减内容，画质高清，最重要的是完全免费！已经推荐给身边所有喜欢看韩漫的朋友了。',
    date: '2026-06-25',
  },
  {
    id: 3,
    name: '樱花落尽',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20elegant%20young%20woman%20with%20long%20hair%2C%20soft%20pastel%20background%2C%20clean%20illustration%20style%2C%20gentle%20expression&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '从其他平台转过来的，真的惊艳到我了！分类很清晰，想找什么类型的漫画都很方便。特别喜欢下拉式阅读模式，不用翻页，体验特别流畅。',
    date: '2026-06-20',
  },
];

export const siteInfo = {
  name: '073漫画网',
  subtitle: '免费韩漫在线阅读',
  description: '073漫画网是国内领先的韩国漫画在线阅读平台，致力于为漫迷提供最优质的韩漫阅读体验。我们拥有海量无删减韩漫资源，涵盖恋爱、热血、奇幻、剧情、搞笑、悬疑等多种类型，每日更新，下拉式阅读，高清全彩，完全免费。',
  stats: {
    totalComics: '20,000+',
    dailyUpdate: '200+',
    totalUsers: '5,800,000+',
    avgRating: '4.9',
  },
  contact: {
    email: 'hello@aduvet.com',
    qq: '1234567890',
    wechat: '073manhuawang',
    address: '中国上海市浦东新区张江高科技园区',
  },
  socialLinks: {
    weibo: 'http://aduvet.com/',
    bilibili: 'http://aduvet.com/',
    zhihu: 'http://aduvet.com/',
  },
};